import React from "react";
import {Col, Form, Row} from "react-bootstrap";
import OeSelect from "../OrderEditor/OeSelect.jsx";
import HelpTooltip from "../HelpTooltip.jsx";

/**
 * Feld „Standarddrucker“ im Benutzerkonto (Benutzerverwaltung und eigenes
 * Profil). Der hier hinterlegte Drucker ist im Auftrags-Editor immer
 * vorausgewählt; ohne Eintrag gilt der zuletzt benutzte. Fällt die
 * Druckerliste aus (kein Druck-Agent erreichbar), bleibt das Feld
 * deaktiviert und der Wert unverändert.
 */
export default function DefaultPrinterField({value, onChange, printers = [], available = true, labelCols = 3}) {
    const aktuell = value || "";
    const options = [{value: "", label: "keiner – zuletzt benutzten nehmen"}];
    printers.forEach((name) => options.push({value: name, label: name}));
    // Ein hinterlegter Drucker, der gerade nicht in der Liste steht, bleibt wählbar.
    if (aktuell && !printers.includes(aktuell)) {
        options.push({value: aktuell, label: `${aktuell} (derzeit nicht gemeldet)`});
    }

    return <Form.Group as={Row} className="mb-3">
        <Form.Label column sm={labelCols}>
            Standarddrucker{" "}
            <HelpTooltip id="tip-standarddrucker" placement="right">
                Dieser Drucker ist im Auftrags-Editor (Druckmaske, Belege, Kommissionierschein) immer
                vorausgewählt. Ohne Eintrag merkt sich der Editor den zuletzt benutzten Drucker.
            </HelpTooltip>
        </Form.Label>
        <Col sm={12 - labelCols}>
            <OeSelect
                className="form-control"
                value={aktuell}
                options={options}
                onChange={(v) => onChange(String(v))}
                ariaLabel="Standarddrucker"
                disabled={!available}
            />
            {!available && <div className="form-text">
                Die Druckerliste ist gerade nicht abrufbar (kein Druck-Agent erreichbar). Der hinterlegte
                Drucker bleibt unverändert.
            </div>}
        </Col>
    </Form.Group>;
}
